module.exports = __webpack_public_path__ + "static/media/app-10@2x.aeb412b2.png";